import { CommandHandler } from './types';

export class HelpCommand implements CommandHandler {
  async execute(): Promise<void> {
    const helpText = [
      '📖 Available commands:',
      '  Basic Game Commands: Explore is the most useful as it tells you details about your environment. You can Explore West (or any direction) to see further. And Explore mine west or build west to toggle between mining or building. ', 
      '       [Spawn] if it doesnt work, try again,',
      '       [Spawn entityID energy] to spawn to a specific spawntile entityID location. Default energy if left blank is 245280000000000000,', 
      '       [Look]/l check your location,', 
      '       [Move] dir (move one block in a direction, directions: north/n, east/e, south/s, west/w, northeast/ne, northwest/nw, southeast/se, southwest/sw),',
      '       [Move] dir dir dir ...fast alternate syntax, you might fall if you dont plan ahead!: Ex: move e e e e e to sprint multiple moves in one transaction, will fail if no path,',
      '       [Survey] detailed horizon sensing - slow wide search for water,',
      '       [Health]/hp,', 
      '       [Explore]/exp examine your immediate environment, set command mine/water/build/till/fill to allow precise block selection,',
      '       [Explore direction] also sets above commands but examines a specific direction for 5 blocks, directions: north/n, east/e, south/s, west/w, northeast/ne, northwest/nw, southeast/se, southwest/sw,',
      '       [Done]/d execute queued actions from above,',
      '       [Speak] say something with symbol single quote before message,',
      '       [Inventory]/inv/i check what you have in storage,',
      '       [Mine] harvest resources at your feet,',
      '  Farming Commands:',
      '       [Till] prepare dirt or grass to become farmland with equipped hoe,',
      '       [Fill] fill equipped bucket with water when standing in water,',
      '       [Fill x y z] fill equipped bucket with water from specific coordinates x y z,',
      '       [Water] water farmland blocks with equipped water bucket,',
      '       [Plant] plant seeds on farmland at your feet with equipped seeds,',
      '       [Build] place equipped block above your head,',
      '       [Mine] down harvest the block beneath you,',
      '       [Craft] item: create new items from your inventory, workbench must be placed one block north when required for crafting items, type craft for even more info.',
      '       [Equip] use a tool from your inventory. Try using axe for wood, and a pick for seed harvesting, if you dont you will take damage!',
      '       [Unequip] stop using your current tool, they break with use!,',
      '       [Eat] first equip the food, then eat food to restore health,',
      '  Combat Commands:',
      '       [Hit] other players with or without an equipped tool, also loots a dead player if standing above them,',
      '       [Hit forcefield x y z] attack a force field at specific coordinates, hit forcefield x y z,',
      '  Force Fields Commands:',
      '       [Energize] power machines with equipped batteries, energize <amount> (default: 1),',
      '       [Sense] check force field status at your location, or at a specific coordinate, sense x y z,',
      '       [ProjectField] create a force field or program at your location, or at a specific coordinate, projectfield x y z,',
      '       [Detach] remove force field or program from a machine, or from your location, example detach x y z,',
      '       [ClaimField x y z] expand access to specified force field to EOA account,',
      '       [ClaimMachine x y z] expand access to specified machine to EOA account, claimmachine x y z, or claimmachine to use your current location, if you are on a machine block, or in a force field, it will use that location,',
      '       [TransferField x y z] transfer force field to another machine, or to your location, transferfield x y z, or transferfield to use your current location, if you are on a machine block, or in a force field, it will use that location, you must own the force field to transfer it, you can check with sense command.',
      '  Other World Commands:',
      '       [Sleep] rest in a bed to guard health and energy. Only works inside of a authenticated force field,',
      '       [Wakeup] awaken from bed to continue adventuring, or wakeup x y z to specify a location 1 block above bed,',
      '       [Scan] search for nearby players, scan radius (default: 10),',
      '       [Loot] collect items at your feet, or at a specific coordinate, loot x y z,',
      '       [Chest] open chest you are standing on, or at a specific coordinate to place or remove items, chest x y z,',
      '       [Building Text Sign for Customized Room] You will need the entityID (bytes32) after crafting it and building it. Run detach x y z of the sign location to get the entityID and enter it here: <a href="https://explorer.mud.dev/redstone/worlds/0x253eb85B3C953bFE3827CC14a151262482E7189C/interact?expanded=permutation%2C0x73797065726d75746174696f6e00000043697479436f756e63696c5797374656%2C0x73797065726d75746174696f6e000000546578745369676e50726f6772616d00%2Cdfprograms_1%2C0x7379646670726f6772616d735f31000044656661756c7450726f6772616d5379#0x7379646670726f6772616d735f31000044656661756c7450726f6772616d5379-0xa00a8b53213bc20902cf4b609fba9f2e72ff076909819fe5a7c50130af1e3c74" target="_blank" rel="noopener noreferrer" class="text-sky-400 hover:underline">Custom Room Description</a>.',
      '       [Map] save your location with a note, map note, map clear to clear all entries,',
      '       [Delegate] address or delegate clear,delegate your dustforgeaccount to another address, or clear delegation,',
      '  AI Commands:',                  
      '       [RegisterAI] configure AI assistant settings for AI mode,',
      '       [CustomAI] add custom instructions to future AI prompts, movement directions, personality,',
      '  Level and Skills:',
      '       [Info] check your level and progress, including steps taken and skills learned, move 5 times to get to level 2, for level 3???',
      '       [Skills] check your level and unlocked skills,',
      '       [Skill name ...] invoke a skill, e.g., skill march west,',
      '       [Skill Info name] check a skill\'s details, e.g., skill info march,',
      '       [Transfer token_address] - transfer ERC20 tokens from session to EOA account,',
      
      '  Also move: north/n, south/s, east/e, west/w, northeast/ne, northwest/nw, southeast/se, southwest/sw, up/u,',
      '  System: help/h, clear, balance/bal, players/who,',
      '  Debug: check forcefield ownership for EOA and session account',
      '  Key Notes: When in explore, looking for a space to move, if you see only AIR in a direction, you will take significant damage. Try placing a block first! Safest movement is with level 2 march skill command!',
      '  Dangers of Batch Mining.  Dont do it for ores! You will die!'
    ];
    
    for (const line of helpText) {
      window.dispatchEvent(new CustomEvent("worker-log", { 
        detail: line 
      }));
    }
  }
}












